"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsPage = exports.PAGE_TITLE = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const DataState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/data/DataState");
const LoadingState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/LoadingState");
const ErrorState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/ErrorState");
const EmptyState_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/state/EmptyState");
const lodash_1 = __importDefault(require("lodash"));
const EventsDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsDataProvider");
const EventsPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageDataProvider");
const EventsPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/event/EventsPageModelProvider");
exports.PAGE_TITLE = "Events";
exports.EventsPage = React.memo(() => {
    const eventsDataContext = (0, EventsDataProvider_1.useEventsDataContext)();
    (0, react_1.useEffect)(() => {
        eventsDataContext.fetchEventNames();
    }, []);
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    const inProgress = eventsDataContext.eventNamesState.inProgress;
    const loaded = eventsDataContext.eventNamesState.loaded;
    const isError = eventsDataContext.eventNamesState.isError;
    const isEmpty = lodash_1.default.isEmpty(eventsDataContext.eventNamesState.data);
    // console.log("EventsPage.render: eventsDataContext", eventsDataContext);
    if (!loaded) {
        if (inProgress) {
            return React.createElement(LoadingState_1.LoadingState, null);
        }
    }
    if (isError) {
        return React.createElement(ErrorState_1.ErrorState, null);
    }
    if (isEmpty) {
        return React.createElement(EmptyState_1.EmptyState, null);
    }
    return React.createElement(EventsPageModelProvider_1.EventsPageModelProvider, null,
        React.createElement(EventsPageDataProvider_1.EventsPageDataProvider, null,
            React.createElement(DataState_1.DataState, null)));
});
